import { PfpRHProvidersComponent } from '../components/P4P/ProviderInfo/RH/PfpRHProvidersComponent';
import { PfpSCOProvidersComponent } from '../components/P4P/ProviderInfo/SCO/PfpSCOProvidersComponent';
import { Constants } from '../constants/appConstants';
import { useAppContext } from '../Context';
import ComponentHeader from './ComponentHeader';

function PfpHome() {
  const { providerType, reviewYear } = useAppContext();
  const isSCOType = providerType === Constants.SCOKey;

  const items = [
    { label: 'Dashboard', path: '/pfp/providers' }
  ];

  return (
    <>
      {isSCOType ?
        <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
          <ComponentHeader
            title='P4P Scoring Portal'
            breadcrumbs={items}
            providerType={providerType}
            reviewYear={reviewYear}
          />
          <PfpSCOProvidersComponent />
        </div>
        :
        <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
          <ComponentHeader
            title='P4P Scoring Portal'
            breadcrumbs={items}
            providerType={providerType}
            reviewYear={reviewYear}
          />
          <PfpRHProvidersComponent />
        </div>
      }
    </>
  );
}

export default PfpHome;